import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import TransporteurSelect from 'components/Shared/TransporteurSelect';
import DropZone from 'components/Shared/DropZone';

import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';

import { getTransporteurEmail } from 'utils/transporteursHelper';

import stringHelper from 'utils/stringHelper';

const styles = theme => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    }
});


class ReponseSouffranceTransporteurContent extends React.Component {

    constructor(props) {
        super(props);

        let state = {
            transporteurId: props.transporteurId,
            destinataires: getTransporteurEmail(props.transporteurId, props.transporteurs, props.depotDepart),
            reference: '',
            memo: 'Ci-joint la réponse à la souffrance numéro : ',
            fichiersIds: [],
            notifierTransporteur: true
        };

        this.state = state;
    }
    
    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (!newState.transporteurId) {
            return null;
        }

        if (newState.notifierTransporteur && !newState.destinataires) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.reference)) {
            return null;
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Transporteur,
                type: ReclamationActionDetailType.TransporteurId,
                libelle: 'Transporteur',
                position: 0,
                valeurInteger: newState.transporteurId
            }, {
                code: ReclamationActionDetailCodes.Reference,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numero de référence souffrance',
                position: 1,
                valeurString: newState.reference
            }]
        };

        if (newState.notifierTransporteur) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Email,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Email(s) destinataire(s)',
                position: actionData.details.length,
                valeurString: newState.destinataires
            });
        }
        else {
            // On n'ajoute pas le mail dans les détails, ce qui suffit à empêcher l'envoi :)
        }

        actionData.details.push({
            code: ReclamationActionDetailCodes.Notifier,
            type: ReclamationActionDetailType.Booleen,
            libelle: 'Envoyer un mail au transporteur',
            position: actionData.details.length,
            valeurBool: newState.notifierTransporteur
        });

        actionData.details.push({
            code: ReclamationActionDetailCodes.Memo,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Mémo',
            position: actionData.details.length,
            valeurString: newState.memo
        });

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {

        const { transporteurs, depotDepart } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (event.target.name === 'transporteurId') {
            newState.destinataires = getTransporteurEmail(newState.transporteurId, transporteurs, depotDepart);
        }

        if (event.target.name === 'reference') {
            newState.memo = 'Ci-joint la réponse à la souffrance numéro : ' + event.target.value;
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes } = this.props;
        const { transporteurId, notifierTransporteur } = this.state;
                
        return (
            <React.Fragment>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>

                <FormControlLabel
                    control={
                        <Switch
                            checked={notifierTransporteur}
                            onChange={e => this.handleChange({ target: { name: "notifierTransporteur", value: !notifierTransporteur } })}
                            value="notifierTransporteur"
                            color="secondary"
                        />
                    }
                    label="Envoyer un mail au transporteur&nbsp;:&nbsp;"
                    labelPlacement="start"
                />

                <TransporteurSelect value={transporteurId} onChange={this.handleChange} all={false} isRequired />

                {notifierTransporteur && <TextField className={classes.input} id="destinataires" name="destinataires" label='Destinataires du mail (séparé par un ";")' type="text" value={this.state.destinataires} onChange={this.handleChange} fullWidth required />}

                <TextField className={classes.input} id="reference" name="reference" label="Indiquer le numero de référence souffrance" type="text" value={this.state.reference} onChange={this.handleChange} fullWidth required />

                <TextField className={classes.input} id="memo" name="memo" label="Mémo" type="text" value={this.state.memo} onChange={this.handleChange} fullWidth multiline />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />

            </React.Fragment>
        );
    }
}

ReponseSouffranceTransporteurContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    transporteurs: PropTypes.array.isRequired
};

export default withStyles(styles)(ReponseSouffranceTransporteurContent);